module.exports = __webpack_public_path__ + "img/crawling-baby-silhouette.c76c9ad5.svg";